/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchInvestmentRequestCreateResponse
 */
export interface BatchInvestmentRequestCreateResponse {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BatchInvestmentRequestCreateResponse
     */
    warnings: { [key: string]: string; };
}

/**
 * Check if a given object implements the BatchInvestmentRequestCreateResponse interface.
 */
export function instanceOfBatchInvestmentRequestCreateResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "warnings" in value;

    return isInstance;
}

export function BatchInvestmentRequestCreateResponseFromJSON(json: any): BatchInvestmentRequestCreateResponse {
    return BatchInvestmentRequestCreateResponseFromJSONTyped(json, false);
}

export function BatchInvestmentRequestCreateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchInvestmentRequestCreateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'warnings': json['warnings'],
    };
}

export function BatchInvestmentRequestCreateResponseToJSON(value?: BatchInvestmentRequestCreateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'warnings': value.warnings,
    };
}

